import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import { managedCompaniesSelector } from '../Settings/store/SettingsSelectors'
import DomainAdmin, { IDomainAdminProps, IDomainAdminDispatchProps } from './DomainAdmin'
import {
  getCompanyDomains,
  addCompanyDomain,
  removeCompanyDomain,
  verifyCompanyDomain,
  getCompanyDomainSettings,
  updateCompanyDomainSettings,
  clearAddedDomain,
} from './store/DomainAdminActions'
import {
  getDomains,
  getDomainsLoading,
  getDomainsAdding,
  getDomainsRemoving,
  getDomainsVerifying,
  getAddedDomain,
  getEmailSignupDomain,
  getGoogleSignupDomain,
  getSettingsLoading,
  getSettingsUpdating,
} from './store/DomainAdminSelectors'
import { getCompanyAdminSelectedCompanyId } from '../CompanyAdmin/store/CompanyAdminSelectors'
import { setCompanyAdminSelectedCompanyId } from '../CompanyAdmin/store/CompanyAdminActions'
import { clearNotification } from '../../common/notifications/NotificationActions'

const mapStateToProps = (state: IGlobalState): IDomainAdminProps => ({
  managedCompanies: managedCompaniesSelector(state),
  domains: getDomains(state),
  loading: getDomainsLoading(state),
  adding: getDomainsAdding(state),
  removing: getDomainsRemoving(state),
  verifying: getDomainsVerifying(state),
  selectedCompanyId: getCompanyAdminSelectedCompanyId(state),
  addedDomain: getAddedDomain(state),
  emailSignupDomain: getEmailSignupDomain(state),
  googleSignupDomain: getGoogleSignupDomain(state),
  settingsLoading: getSettingsLoading(state),
  settingsUpdating: getSettingsUpdating(state),
})

const mapDispatchToProps: IDomainAdminDispatchProps = {
  getCompanyDomains,
  addCompanyDomain,
  removeCompanyDomain,
  verifyCompanyDomain,
  setDomainSelectedCompanyId: setCompanyAdminSelectedCompanyId,
  getCompanyDomainSettings,
  updateCompanyDomainSettings,
  clearAddedDomain,
  clearNotification,
}

export default connect(mapStateToProps, mapDispatchToProps)(DomainAdmin)
